var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVietnamEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 193,
    viewBox: "0 0 76 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1149 86.5789L38.0259 192.33L26.8047 86.5789C34.0529 88.9469 41.8666 88.9469 49.1149 86.5789Z",
    fill: "#DA251D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78.5904C58.9868 78.5904 76 60.9973 76 39.2952C76 17.5931 58.9868 0 38 0C17.0132 0 0 17.5931 0 39.2952C0 60.9973 17.0132 78.5904 38 78.5904Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1223_5",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 79
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78.5904C58.9868 78.5904 76 60.9973 76 39.2952C76 17.5931 58.9868 0 38 0C17.0132 0 0 17.5931 0 39.2952C0 60.9973 17.0132 78.5904 38 78.5904Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1223_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0039 78.5904C58.9907 78.5904 76.0039 60.9973 76.0039 39.2952C76.0039 17.5931 58.9907 0 38.0039 0C17.0171 0 0.00390625 17.5931 0.00390625 39.2952C0.00390625 60.9973 17.0171 78.5904 38.0039 78.5904Z",
    fill: "#DA251D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.503906 14.1711H76.4277V64.6567H-0.503906V14.1711Z",
    fill: "#DA251D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9619 24.2994L41.3553 34.7437H52.3364L43.4525 41.1975L46.8458 51.6419L37.9619 45.1863L29.078 51.6419L32.4713 41.1975L23.5874 34.7437H34.5686L37.9619 24.2994Z",
    fill: "#FFFF00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietnamEmployees);
export default __webpack_public_path__ + "static/media/vietnamEmployees.df2afc6e58cb840b1aba4624bfe892ef.svg";
export { ForwardRef as ReactComponent };